// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-qnh","question":"styles_question__kB9Z_","description":"styles_description__3o-UP"};